export function getUserNameFromJwt(pJwt: string): string {
  if (!pJwt) return "";

  const lParts = pJwt.split(".");
  if (lParts.length < 2) return "";

  let lPayload = lParts[1].replace(/-/g, "+").replace(/_/g, "/");
  const lPad = lPayload.length % 4;
  if (lPad) {
    lPayload += "=".repeat(4 - lPad);
  }

  try {
    const lJson = JSON.parse(atob(lPayload));
    return lJson?.UserName || "";
  } catch {
    return "";
  }
}

export function isJwtExpired(token: string): boolean {
  if (!token) return true;

  try {
    const payloadBase64 = token.split(".")[1];
    if (!payloadBase64) return true;

    const payload = JSON.parse(atob(payloadBase64));
    const exp = payload?.exp;

    if (!exp) return true;

    // exp is in seconds, Date.now() is ms
    return exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export function getSafeReturnUrl(pReturnUrl: string): string {
  if (!pReturnUrl) return "/";
  if (!pReturnUrl.startsWith("/")) return "/";
  if (pReturnUrl.startsWith("//")) return "/";
  if (pReturnUrl.toLowerCase().startsWith("/login")) return "/";
  if (pReturnUrl.toLowerCase().startsWith("/sso")) return "/";
  return pReturnUrl;
}